import * as React from "react";
import Select from "@mui/material/Select";
import { states, timeZoneArray } from "components/helpers";
import { FormHelperText, Grid, TextField } from "@mui/material";
import {
  Controller,
  useFormContext,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import "./styles.css";
import htmlText from "../htmlText";

export default function PracticeLocationInformation() {
  const {
    control,
    formState: { errors },
    trigger,
    getValues,
  } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "practice_location",
  });
  const watchedValue = useWatch("practice_location");
  const { provider } = getValues();

  const locationField = watchedValue?.practice_location.length
    ? watchedValue?.practice_location
    : fields;

  return (
    <>
      {locationField.map((item, index) => (
        <>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Select Provider</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location.${index}.selectedProvider`}
                control={control}
                defaultValue={item.selectedProvider}
                render={({ field }) => (
                  <>
                    <Select
                      variant="standard"
                      native
                      style={{ width: "100%" }}
                      {...field}
                    >
                      <option value=""></option>
                      {provider.map((s, i) => (
                        <option key={i} value={i}>
                          {s.first_name} {s.last_name}
                        </option>
                      ))}
                    </Select>
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Email</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].email`}
                control={control}
                defaultValue={item.email}
                rules={{
                  required: false,
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Invalid email address",
                  },
                }}
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.email)
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].email`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.email?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(errors?.practice_location[index]?.email)
                          }
                        >
                          {errors?.practice_location[index]?.email?.message}
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Address Line 1</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].address_line1`}
                control={control}
                rules={{ required: htmlText.thisFieldIsRequired }}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].address1
                    : item.address_line1
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].address1
                    : item.address_line1
                }
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.address_line1)
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].address_line1`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.address_line1
                        ?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(
                              errors?.practice_location[index]?.address_line1
                            )
                          }
                        >
                          {
                            errors?.practice_location[index]?.address_line1
                              ?.message
                          }
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Address Line 2</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].address_line2`}
                control={control}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].address2
                    : item.address_line2
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].address2
                    : item.address_line2
                }
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      required
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.address_line2)
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].address_line2`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.address_line2
                        ?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(
                              errors?.practice_location[index]?.address_line2
                            )
                          }
                        >
                          {
                            errors?.practice_location[index]?.address_line2
                              ?.message
                          }
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>City</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].city`}
                control={control}
                rules={{ required: htmlText.thisFieldIsRequired }}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].city
                    : item.city
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].city
                    : item.city
                }
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.city)
                      }
                      onBlur={() => trigger(`practice_location[${index}].city`)}
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.city?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(errors?.practice_location[index]?.city)
                          }
                        >
                          {errors?.practice_location[index]?.city?.message}
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>State</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].state_cd`}
                control={control}
                rules={{ required: htmlText.thisFieldIsRequired }}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].state_cd
                    : item.state_cd
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].state_cd
                    : item.state_cd
                }
                render={({ field }) => (
                  <>
                    <Select
                      variant="standard"
                      native
                      style={{ width: "100%" }}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.state_cd)
                      }
                      {...field}
                    >
                      <option value=""></option>
                      {states.map((s) => (
                        <option key={s.value} value={s.value}>
                          {s.label}
                        </option>
                      ))}
                    </Select>
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.state_cd?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(errors?.practice_location[index]?.state_cd)
                          }
                        >
                          {errors?.practice_location[index]?.state_cd?.message}
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Zip Code</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].zip_code`}
                control={control}
                rules={{ required: htmlText.thisFieldIsRequired }}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].zip
                    : item.zip_code
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].zip
                    : item.zip_code
                }
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.zip_code)
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].zip_code`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.zip_code?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(errors?.practice_location[index]?.zip_code)
                          }
                        >
                          {errors?.practice_location[index]?.zip_code?.message}
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Phone No</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].phone`}
                control={control}
                key={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].phone
                    : item.phone
                }
                defaultValue={
                  item?.selectedProvider
                    ? provider[Number(item?.selectedProvider)].phone
                    : item.phone
                }
                rules={{
                  required: false,
                  pattern: {
                    value: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                    message: "Invalid contact number",
                  },
                }}
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(errors?.practice_location[index]?.phone)
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].phone`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.phone?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(errors?.practice_location[index]?.phone)
                          }
                        >
                          {errors?.practice_location[index]?.phone?.message}
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Time Zone</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location.${index}.time_zone`}
                control={control}
                defaultValue={item.time_zone || "EST"}
                render={({ field }) => (
                  <>
                    <Select
                      variant="standard"
                      native
                      style={{ width: "100%" }}
                      {...field}
                    >
                      <option value=""></option>
                      {timeZoneArray.map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </Select>
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Service location Code</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].service_loc_code`}
                control={control}
                defaultValue={item.service_loc_code}
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(
                          errors?.practice_location[index]?.service_loc_code
                        )
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].service_loc_code`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.service_loc_code
                        ?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(
                              errors?.practice_location[index]?.service_loc_code
                            )
                          }
                        >
                          {
                            errors?.practice_location[index]?.service_loc_code
                              ?.message
                          }
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Service location description</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].service_loc_description`}
                control={control}
                defaultValue={item.service_loc_description}
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(
                          errors?.practice_location[index]
                            ?.service_loc_description
                        )
                      }
                      onBlur={() =>
                        trigger(
                          `practice_location[${index}].service_loc_description`
                        )
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.service_loc_description
                        ?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(
                              errors?.practice_location[index]
                                ?.service_loc_description
                            )
                          }
                        >
                          {
                            errors?.practice_location[index]
                              ?.service_loc_description?.message
                          }
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <Grid item xs={6}>
              <p>Service location NPI</p>
            </Grid>
            <Grid item xs={6}>
              <Controller
                name={`practice_location[${index}].service_loc_npi`}
                control={control}
                defaultValue={item.service_loc_npi}
                rules={{
                  required: false,
                  pattern: {
                    value: /^\d{10}$/,
                    message: "NPI should be 10 digits",
                  },
                }}
                render={({ field }) => (
                  <>
                    <TextField
                      fullWidth
                      size="small"
                      sx={{ marginBottom: 0 }}
                      {...field}
                      error={
                        errors?.practice_location &&
                        Boolean(
                          errors?.practice_location[index]?.service_loc_npi
                        )
                      }
                      onBlur={() =>
                        trigger(`practice_location[${index}].service_loc_npi`)
                      }
                    />
                    {errors?.practice_location &&
                      errors?.practice_location[index]?.service_loc_npi
                        ?.message && (
                        <FormHelperText
                          error={
                            errors?.practice_location &&
                            Boolean(
                              errors?.practice_location[index]?.service_loc_npi
                            )
                          }
                        >
                          {
                            errors?.practice_location[index]?.service_loc_npi
                              ?.message
                          }
                        </FormHelperText>
                      )}
                  </>
                )}
              />
            </Grid>
          </Grid>
        </>
      ))}
    </>
  );
}
